import React from "react";

function DefaultInvoice({ logo, general, data, invoice }) {
  const date = new Date();

  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();

  // This arrangement can be altered based on how we want the date's format to appear.
  let currentDate = `${day}-${month}-${year}`;
  let currentDateSlash = `${month}/${day}/${year}`;

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  let currentTime = `${hours}:${minutes}:${seconds}`;

  function formatDate(inputDate) {
    // Split date and time
    const [date] = inputDate.split(" ");
    // Split year, month, and day
    const [year, month, day] = date.split("-");
    // Return formatted date as MM/DD/YYYY
    return `${month}/${day}/${year}`;
  }

  return (
    <>
      <div className="w-full max-w-3xl mx-auto py-8 px-16">
        <img src={logo} className="mx-auto w-32" alt="" />
        <h1 className="text-4xl font-medium text-center mt-6">
          {general.restaurant_name}
        </h1>
        <div className="text-center text-2xl mt-2">
          <p>{general.address}</p>
          <p>Tel: {general.phone}</p>
          <p>فاتورة ضريبية مبسطة</p>
          {/* <p>(24-11-04-000166)</p> */}
          <p>({`${currentDate}-${data.token_no}`})</p>
        </div>
        <p className="mt-2 font-bold text-2xl text-center">
          Tax Registration No: {general.tax_reg_no}
        </p>
        <div className="flex justify-between gap-4 mt-16 text-lg">
          <div>({Number(data.token_no)})</div>
          <div className="text-end">
            <p>Order Type: {data.order_type?.type}</p>
            <p>
              Cutomer Name:{" "}
              {data.is_guest === "no" ? data.customer?.name : data.guest?.name}
            </p>
            {data.order_type_id === 2 && (
              <p>
                Cutomer Number:{" "}
                {data.is_guest === "no"
                  ? data.customer?.phone
                  : data.guest?.phone}
              </p>
            )}
            <p>Cashier Name: {data.cashier?.name}</p>
          </div>
        </div>
        <div className="flex justify-between text-xl font-medium mt-4">
          <p className="px-4">Selling Point 1</p>
          <p className="px-4">Sales Associate Admin</p>
        </div>
        <table className="w-full text-xl">
          <thead>
            <tr className="border-b-2 border-t-2 border-dotted border-black">
              <th className="py-1 text-start">Qty</th>
              <th className="py-1 whitespace-nowrap text-start">Name</th>
              <th className="py-1 text-start">Code</th>
              <th className="py-1 text-end">Price</th>
            </tr>
          </thead>
          <tbody>
            {data.order_details?.map((orderItem, index) => (
              <>
                <tr
                  key={index}
                  className={
                    orderItem.modifiers.length === 0 &&
                    `border-b-2 border-black border-dotted`
                  }
                >
                  <td>{orderItem.qty}</td>
                  <td>
                    <p>
                      {orderItem.name} / {orderItem.name_arabic}
                    </p>
                  </td>
                  <td>
                    {orderItem.menu_taxes.additional_vat_percentage === 100
                      ? `T - ${orderItem.menu_taxes.additional_vat_percentage}%`
                      : orderItem.menu_taxes.vat_percentage === 15
                      ? `V -  ${orderItem.menu_taxes.vat_percentage}%`
                      : orderItem.menu_taxes.vat_percentage === 0
                      ? `Z - ${orderItem.menu_taxes.vat_percentage}%`
                      : "Exemption"}
                  </td>
                  <td className="py-2 px-4 text-end">
                    {orderItem.menu_unit_price_with_vat.toFixed(2) ===
                    orderItem.menu_price_with_discount.toFixed(2) ? (
                      <p>{orderItem.menu_unit_price_with_vat.toFixed(2) * orderItem.qty}</p>
                    ) : (
                      <span className="flex gap-2">
                        <p className="line-through">
                          {orderItem.menu_unit_price_with_vat.toFixed(2) * orderItem.qty}
                        </p>
                        <p>{orderItem.menu_price_with_discount.toFixed(2) * orderItem.qty}</p>
                      </span>
                    )}
                  </td>
                </tr>
                {orderItem.food_menu.is_deal === "yes" && (
                    <tr>
                      <td colSpan={5}>
                        {orderItem.food_menu.deal_details && JSON.parse(orderItem.food_menu.deal_details)?.map((deal, index) => (
                          <p key={index}>{`${deal.qty}x ${deal.name}`}</p>
                        ))}
                      </td>
                    </tr>
                  )}
                {orderItem.modifiers.map((mod, index) => (
                  <tr
                    key={index}
                    className={
                      orderItem.modifiers.length === index + 1 &&
                      `border-b-2 border-black border-dotted`
                    }
                  >
                    <td colSpan={3}>{mod.name}</td>
                    <td className="text-end">{mod.price * orderItem.qty}</td>
                  </tr>
                ))}
              </>
            ))}
          </tbody>
          <tbody className="font-medium">
            <tr className="border-b-2 border-black border-dotted">
              <td colSpan={2}>Total</td>
              <td>{data.total_payable.toFixed(2)}</td>
              <td>S.R</td>
            </tr>
            <tr className="border-b-2 border-black border-dotted">
              <td colSpan={2}>Sub Total</td>
              <td>{data.sub_total.toFixed(2)}</td>
              <td>S.R</td>
            </tr>
            {data.total_discount_amount !== 0 && (
              <tr className="border-b-2 border-black border-dotted">
                <td colSpan={2}>Discount</td>
                <td>{data.total_discount_amount.toFixed(2)}</td>
                <td>S.R</td>
              </tr>
            )}
            {data.delivery_charges !== 0 && (
              <tr className="border-b-2 border-black border-dotted">
                <td colSpan={2}>Service/Delivery</td>
                <td>{data.delivery_charges.toFixed(2)}</td>
                <td>S.R</td>
              </tr>
            )}
            <tr className="border-b-2 border-black border-dotted">
              <td colSpan={2}>VAT</td>
              <td>{data.vat_amount.toFixed(2)}</td>
              <td>S.R</td>
            </tr>
            <tr className="border-b-2 border-black border-dotted">
              <td colSpan={2}>Grand Total</td>
              <td>{data.total_payable}</td>
              <td>S.R</td>
            </tr>
          </tbody>
          <tbody>
            {data.payment.name === "Multi Cash" ? (
              data.multiple_payments.map((payments, index) =>
                payments.company_name === "Cash" ? (
                  <>
                    <tr
                      key={index}
                      className="border-b-2 border-black border-dotted"
                    >
                      <td colSpan={2}>{payments.company_name}</td>
                      <td>{payments.amount}</td>
                      <td>S.R</td>
                    </tr>
                    <tr
                      key={index}
                      className="border-b-2 border-black border-dotted"
                    >
                      <td colSpan={2}>Total Paid (Cash)</td>
                      <td>{payments.amount}</td>
                      <td>S.R</td>
                    </tr>
                  </>
                ) : (
                  <>
                    <tr key={index} className="">
                      <td colSpan={2}>Credit Card</td>
                      <td>{payments.amount}</td>
                      <td>S.R</td>
                    </tr>
                    <tr>
                      <td colSpan={3}>Input Method</td>
                      <td>Terminal</td>
                    </tr>
                    <tr>
                      <td colSpan={3}>Card Company</td>
                      <td>{payments.company_name}</td>
                    </tr>
                    <tr className="border-b-2 border-t-2">
                      <td colSpan={3}>Certified Amount</td>
                      <td>{payments.amount}</td>
                    </tr>
                  </>
                )
              )
            ) : data.payment.name === "Cash" ? (
              <tr className="border-b-2 border-black border-dotted">
                <td colSpan={2}>{data.payment.name}</td>
                <td>{data.total_payable}</td>
                <td>S.R</td>
              </tr>
            ) : (
              <>
                <tr>
                  <td colSpan={2}>Credit Card</td>
                  <td>{data.total_payable}</td>
                  <td>S.R</td>
                </tr>
                <tr>
                  <td colSpan={3}>Input Method</td>
                  <td>Terminal</td>
                </tr>
                <tr>
                  <td colSpan={3}>Card Company</td>
                  <td>{data.payment.name}</td>
                </tr>
                <tr className="border-b-2 border-t-2">
                  <td colSpan={3}>Certified Amount</td>
                  <td>{data.total_payable}</td>
                </tr>
              </>
            )}
          </tbody>
        </table>
        {<VatTable data={data.order_details} />}

        <div className="text-center text-xl space-y-4 mt-4">
          {invoice.invoice_footer && <p>{invoice.invoice_footer}</p>}
          {invoice.invoice_footer1 && <p>{invoice.invoice_footer1}</p>}
          {invoice.invoice_footer2 && <p>{invoice.invoice_footer2}</p>}
        </div>
        <div className="text-xl">
          {invoice.order_date === "yes" && (
            <div className="flex justify-between">
              <div>
                <p>Order Date</p>
              </div>
              <div className="flex space-x-5">
                {" "}
                <p>{formatDate(data.sale_date)}</p>
                <span>{data.order_time}</span>
              </div>
            </div>
          )}
          {invoice.statement_date === "yes" && (
            <div className="flex justify-between">
              <div>
                <p>Statement Date</p>
              </div>
              <div className="flex space-x-5">
                <p>{formatDate(data.sale_date)}</p>
                <span>{data.order_time}</span>
              </div>
            </div>
          )}
          {invoice.print_date === "yes" && (
            <div className="flex justify-between">
              <div>
                <p>Print Date</p>
              </div>
              <div className="flex space-x-5">
                {" "}
                <p>{currentDateSlash}</p>
                <span>{currentTime}</span>
              </div>
            </div>
          )}
        </div>
        <div>
          <img src={data.qr_image_url} className="w-64 mx-auto mt-4" alt="" />
          <p className="text-2xl mt-16 text-center font-bold">
            QRالفاتورة االلكترونية
          </p>
        </div>
      </div>
    </>
  );
}

const VatTable = ({ data }) => {
  // Group items by VAT code
  const groupedItems = data.reduce((acc, orderItem) => {
    const { menu_taxes } = orderItem;
    let code;

    // Determine the VAT code based on given conditions
    if (menu_taxes.additional_vat_percentage === 100) {
      code = `T - ${menu_taxes.additional_vat_percentage}%`;
    } else if (menu_taxes.vat_percentage === 15) {
      code = `V - ${menu_taxes.vat_percentage}%`;
    } else if (menu_taxes.vat_percentage === 0) {
      code = `Z - ${menu_taxes.vat_percentage}%`;
    } else {
      code = `VAT - ${menu_taxes.vat_percentage}%`;
    }

    // Grouping logic
    if (!acc[code]) {
      acc[code] = {
        totalAmount: 0,
        totalVat: 0,
        vatRate: menu_taxes.vat_percentage,
      };
    }

    // Add the current item's amount and VAT to the group
    acc[code].totalAmount += menu_taxes.total_qty_items_price || 0;
    acc[code].totalVat += menu_taxes.total_qty_vat || 0;
    return acc;
  }, {});

  // Convert grouped object to array for table rendering
  const groupedArray = Object.entries(groupedItems).map(([code, data]) => ({
    code,
    vatRate: data.vatRate,
    totalAmount: data.totalAmount.toFixed(2),
    totalVat: data.totalVat.toFixed(2),
    total: (data.totalAmount + data.totalVat).toFixed(2),
  }));

  return (
    <table className="w-full">
      <thead>
        <tr className="border-b-2 border-black border-dotted">
          <th className="text-start">Code</th>
          <th className="text-start">Tax Rate</th>
          <th className="text-start">Amount</th>
          <th className="text-start">Tax</th>
          <th className="text-start">Total</th>
        </tr>
      </thead>
      <tbody>
        {groupedArray.map((item, index) => (
          <tr key={index} className="border-b-2 border-black border-dotted">
            <td>{item.code}</td>
            <td>{item.vatRate}%</td>
            <td>{item.totalAmount}</td>
            <td>{item.totalVat}</td>
            <td>{item.total}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default DefaultInvoice;
